import { event } from '../../kastjs/event-bus';
import { aopFactory } from './aop';
import { getGlobalAuthStore } from '../../kastjs/upm';

import type { PluginFunction } from '@kastjs/runtime-core';

export interface MicroPlugin {}

const microPlugin: PluginFunction<MicroPlugin> = async context => {
  const { appSettings } = context;
  const authStore = getGlobalAuthStore();

  event.emit('child-app-ready', { appSettings, authStore });
};

export const microPluginAOP = aopFactory(microPlugin, {});
export default microPlugin;
